import { DatabaseIdTypes } from '../../Enums/ChoiceEnums';
import { IDatabaseIdModel } from '../Models/DatabaseIdModel';
// Get the interger value with the specified prefix
export function parsePrefixedInt(textWithPrefixAndIntValue: string, prefixText: string): number | undefined
{
    const regExPatientEntityID = RegExp(prefixText + "(\\d+)", "i");
    const match = regExPatientEntityID.exec(textWithPrefixAndIntValue);

    if (!match?.length)
        return;
    
    return parseInt(match[1]);
}

// Determine if the value matches one of the prefixs associated with a database ID type
export function parsePrefixedIntOptions(textWithPrefixAndIntValue: string, prefixItems: IPrefixItemModel[]): IDatabaseIdModel | undefined
{
    for (const prefixItem of prefixItems)
    {
        const possibleId = parsePrefixedInt(textWithPrefixAndIntValue, prefixItem.prefixText);
        if (possibleId)
            return { id: possibleId, idType: prefixItem.idType };
    }
}

export interface IPrefixItemModel
{
    prefixText: string,
    idType: DatabaseIdTypes
}
